import React from "react"
import { Link, NavLink } from "react-router-dom"

const DATA_NAV = [
  { to: "/", key: "overview", index: "01", end: true },
  { to: "/experiments", key: "experiments", index: "02" },
  { to: "/proposals", key: "proposals", index: "03" },
  { to: "/funnel", key: "funnel", index: "04" }
]

const SETUP_NAV = [
  { to: "/script", key: "script", index: "05" },
  { to: "/profile", key: "profile", index: "06" },
  { to: "/settings", key: "settings", index: "07" }
]

function NavItem({ t, to, itemKey, index, end, pendingCount }) {
  return (
    <NavLink to={to} end={end} className={({ isActive }) => [
      "flex justify-between items-center px-[10px] py-[7px] text-[13px] rounded-[4px] border-l-2",
      isActive
        ? "font-medium text-white border-ai"
        : "text-ink-on-dark-muted border-transparent hover:text-white"
    ].join(" ")} style={({ isActive }) => ({
      background: isActive ? "rgba(255,255,255,0.08)" : "transparent"
    })}>
      {({ isActive }) => (
        <>
          <span>{t(`dashboard.nav.${itemKey}`)}</span>
          {pendingCount != null && pendingCount > 0 ? (
            <span className="font-medium text-[10px] px-[7px] py-[1px] rounded-pill text-white bg-ai">
              {pendingCount}
            </span>
          ) : (
            <span
              className={`font-mono text-[10px] ${isActive ? "text-ink-on-dark-muted" : "text-ink-on-dark-faint"}`}
              style={{ fontVariantNumeric: "tabular-nums" }}
            >
              {index}
            </span>
          )}
        </>
      )}
    </NavLink>
  )
}

function StatusFooterItem({ to, dotColor, pulse, labelClass, label, sublabel }) {
  return (
    <Link
      to={to}
      className="block px-[10px] hover:opacity-90 transition-opacity"
    >
      <div className="flex items-center gap-2 text-[12px] text-white">
        <span
          className={`inline-block w-[6px] h-[6px] rounded-full ${pulse ? "animate-pulse" : ""}`}
          style={{ background: dotColor }}
        />
        <span className={labelClass}>{label}</span>
      </div>
      <div
        className="mt-1 font-mono text-[10px] text-ink-on-dark-faint"
        style={{ letterSpacing: "0.12em", fontVariantNumeric: "tabular-nums" }}
      >
        {sublabel}
      </div>
    </Link>
  )
}

export default function Sidebar({ t, pendingProposalsCount = 0, scriptInstalled = false, conversionDefined = false }) {
  return (
    <nav
      className="flex flex-col gap-[1px] pt-[22px] px-[14px] pb-4 text-ink-on-dark"
      style={{ background: "#1E293B" }}
    >
      <div className="px-[10px] pb-4 mb-[14px] border-b" style={{ borderColor: "rgba(255,255,255,0.08)" }}>
        <div
          className="font-mono text-[11px] text-ink-on-dark-faint mb-1"
          style={{ letterSpacing: "0.1em" }}
        >
          {t("dashboard.nav.tagline")}
        </div>
        <div className="text-[17px] text-white font-medium tracking-[-0.025em]">
          ShopShift<span className="text-ai">.</span>
        </div>
      </div>

      <div className="font-mono text-[10px] text-ink-on-dark-faint px-[10px] pb-2 pt-[2px]"
           style={{ letterSpacing: "0.12em" }}>
        {t("dashboard.nav.data")}
      </div>
      {DATA_NAV.map((item) => (
        <NavItem
          key={item.key}
          t={t}
          to={item.to}
          itemKey={item.key}
          index={item.index}
          end={item.end}
          pendingCount={item.key === "proposals" ? pendingProposalsCount : null}
        />
      ))}

      <div className="font-mono text-[10px] text-ink-on-dark-faint px-[10px] pb-2 pt-[18px]"
           style={{ letterSpacing: "0.12em" }}>
        {t("dashboard.nav.setup")}
      </div>
      {SETUP_NAV.map((item) => (
        <NavItem key={item.key} t={t} to={item.to} itemKey={item.key} index={item.index} />
      ))}

      <div className="mt-auto pt-6 flex flex-col gap-3">
        <StatusFooterItem
          to="/script"
          dotColor={scriptInstalled ? "#34D399" : "var(--color-ink-tertiary)"}
          pulse={scriptInstalled}
          labelClass={scriptInstalled ? "text-white" : "text-ink-on-dark-muted"}
          label={scriptInstalled
            ? t("dashboard.nav.connected")
            : t("dashboard.nav.script_not_installed")}
          sublabel={scriptInstalled
            ? t("dashboard.nav.shop_active")
            : t("dashboard.nav.script_install_cta")}
        />
        <StatusFooterItem
          to="/settings"
          dotColor={conversionDefined ? "#34D399" : "var(--color-ink-tertiary)"}
          pulse={conversionDefined}
          labelClass={conversionDefined ? "text-white" : "text-ink-on-dark-muted"}
          label={conversionDefined
            ? t("dashboard.nav.conversion_tracking_on")
            : t("dashboard.nav.conversion_not_defined")}
          sublabel={conversionDefined
            ? t("dashboard.nav.conversion_tracking_label")
            : t("dashboard.nav.conversion_define_cta")}
        />
      </div>
    </nav>
  )
}
